import React, { useState } from "react";

const faqs = [
  {
    question: "Comment m’inscrire à un atelier ?",
    answer:
      "Tu peux t’inscrire directement via la plateforme GoNextMaker, en choisissant l’atelier qui t’intéresse et en suivant les étapes de validation.",
  },
  {
    question: "Comment fonctionne le paiement ?",
    answer:
      "Les paiements se font en ligne de manière sécurisée. Plusieurs moyens de paiement sont acceptés (mobile money, carte bancaire…).",
  },
  {
    question: "Puis-je rejoindre un atelier sans ordinateur ?",
    answer:
      "Oui, certains ateliers sont accessibles sans ordinateur. Vérifie dans la description de l’atelier si c’est le cas.",
  },
  {
    question: "Comment contacter un tuteur ?",
    answer:
      "Une fois inscrit, tu peux contacter ton tuteur via la messagerie intégrée de la plateforme ou par les moyens indiqués.",
  },
  {
    question: "Que faire si j’ai oublié mon mot de passe ?",
    answer:
      "Clique sur « Mot de passe oublié » à la connexion. Tu recevras un email pour réinitialiser ton mot de passe.",
  },
];

const HelpFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full bg-white py-12 px-6">
      <div className="max-w-4xl mx-auto">
        <h3 className="text-title font-bold text-dark-1 mb-6 text-center">
          Questions fréquentes
        </h3>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-light-2 rounded-lg shadow-sm"
            >
              {/* Question */}
              <button
                className="w-full flex justify-between items-center text-left px-4 py-3 font-medium text-dark-1 hover:bg-light-5 transition"
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <span className="text-blue-1">
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>

              {/* Réponse */}
              {openIndex === index && (
                <div className="px-4 pb-4 text-light-1 text-sm leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HelpFAQ;
